module.exports = __webpack_public_path__ + "fonts/Play-Exchange-Icons.b451422.eot";